import styled from "styled-components";
import theme from "../../../../Styles/theme";

export const Container = styled.div``;

export const SectionTitle = styled.h3`
  color: ${theme.colors.dark};
  font-weight: bold;
  font-size: max(1.2vw, 12px);
  text-align: center;
  width: 100%;
`;

interface SectionProps{
    disabled:boolean;
}
export const Section = styled.section<SectionProps>`
 /* opacity: ${({disabled})=> disabled? '0.7' : '1'}; */
/* cursor:${({disabled})=> disabled? 'not-allowed' : ''};; */
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 1vh;
`;

export const ContainertInput = styled.div`
  width: 100%;
  margin-top: 1vh;
  display: flex;
  align-items: center;
`;

export const Label = styled.label`
  width: 100%;
  font-size: max(1vw, 10px);
  color: ${theme.colors.dark};
  font-weight: bold;
`;

export const LabelRadioButton = styled.label`
 font-size: max(1vw, 10px);
  color: ${theme.colors.dark};
  font-weight: bold;

`;

export const Input = styled.input`
  width: 100%;
  background: ${theme.colors.light};
  border: none;
  color: ${theme.colors.dark};
  font-size: max(1vw, 10px);
  padding: 1vh 2vw;
  border-radius: 0.25rem;
`;

export const Textarea = styled.textarea`
  width: 100%;
  background: ${theme.colors.light};
  border: none;
  color: ${theme.colors.dark};
  font-size: max(1vw, 10px);
  padding: 1vh 2vw;
  border-radius: 0.25rem;
  resize: none;
  
`;


export const Button = styled.button`
  margin: auto;

  background-color: ${theme.colors.darkGrey};
  font-size: max(1vw, 10px);
  font-weight: bold;
  color: ${theme.colors.dark};
  padding: 1vh 2vw;
  border-radius: 0.25rem;
  margin: auto;
  margin-top: 1vh;
  &:hover {
    opacity: 0.7;
  }
`;

export const HelperCentralize= styled.div`
  display:flex;
  align-items: center;
  justify-content:space-around;
  width: 100%;
  /* background-color: ${theme.colors.attention}; */

`;
export const TipoNaoTributadoButton = styled.button`

  color: ${theme.colors.dark};
  background-color: ${theme.colors.light};
    display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: max(1.2vw, 10px);

  
  border-radius: 0.25rem;
  padding: 1vh 2vw;
`;